import { fetchWithTimeout } from '../helpers/apiHelpers';
import { PUBLIC_API_BASE_URL } from '../config/api';
import { ApiResponse, ApiResult } from '../types/api/common';
import { InsurersResponse } from '../types/api/responses';

export const insurersService = async (): Promise<ApiResult<InsurersResponse>> => {
  try {
    const response = await fetchWithTimeout(`${PUBLIC_API_BASE_URL}/insurers`, {
      method: 'GET',
    });
    const json = (await response.json()) as ApiResponse<InsurersResponse>;
    return [null, json];
  } catch (error) {
    return [error as Error, null];
  }
};
